var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ProfileInfoV1 } from '@s7/mfe-profile-info';
import React from 'react';
var PUBLIC_ASSET_PREFIX = process.env.REACT_APP_PUBLIC_ASSET_PREFIX;
var MFE_PROFILE_INFO_URL = process.env.REACT_APP_MFE_PROFILE_INFO_URL;
var APPLICATION_IDENT = process.env.REACT_APP_APPLICATION_IDENT;
export var ProfileInfoWidget = function (props) {
    var lang = props.lang, others = __rest(props, ["lang"]);
    return (React.createElement(ProfileInfoV1, __assign({}, others, { menuUrl: "".concat(PUBLIC_ASSET_PREFIX, "/public/v1/profile-info-navigation-menu-").concat(lang !== null && lang !== void 0 ? lang : 'ru', ".json"), mfeUrl: MFE_PROFILE_INFO_URL, origin: APPLICATION_IDENT })));
};
